(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jungle-split"] && !Shopify.designMode) return;
  try {
    
function jungleFooterMobile() {
  if (!document.body.classList.contains('template-index')) return;
  const mobile = window.matchMedia('(max-width:767px)');
  document.querySelectorAll('.section-footer__menu-block').forEach((block, index) => {
    const title = block.querySelector('.section-footer__title');
    const menu = block.querySelector('ul');
    if (!title || !menu || title.querySelector('button')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mj-footer-toggle';
    button.textContent = title.textContent.trim();
    menu.id = menu.id || 'mj-footer-menu-' + index;
    button.setAttribute('aria-controls', menu.id);
    title.replaceChildren(button);
    const update = () => {
      button.disabled = !mobile.matches;
      button.setAttribute('aria-expanded', String(!mobile.matches));
      menu.hidden = mobile.matches;
    };
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
    });
    mobile.addEventListener('change', update);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jungleFooterMobile);
else jungleFooterMobile();
document.addEventListener('shopify:section:load', jungleFooterMobile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
